import {
  BaseLayoutSchema,
  CommonInputWidgetConfigSchema,
  RichTextAdvancedSchema,
} from '@framework/engine';
import { yup } from '@framework/validation';
import {
  IEmailVerificationWidget,
  WidgetEmailVerificationType,
} from './IEmailVerificationWidget';

export const EmailVerificationWidgetConfigSchema: yup.ObjectSchema<IEmailVerificationWidget> =
  CommonInputWidgetConfigSchema.shape({
    type: yup
      .string()
      .required()
      .exact(WidgetEmailVerificationType)
      .label('Tipo'),
    layout: BaseLayoutSchema.shape({
      startButtonText: yup
        .string()
        .optional()
        .default('Verifica Email')
        .label('Testo pulsante iniziale'),
      startHelpText: RichTextAdvancedSchema.optional().label(
        'Testo di aiuto iniziale',
      ),
      endButtonText: yup
        .string()
        .optional()
        .default('Conferma Ricezione')
        .label('Testo pulsante verifica'),
      endHelpText: RichTextAdvancedSchema.optional().label(
        'Testo di aiuto verifica',
      ),
    }),
  })
    .required()
    .noUnknown();
